import { useLocation } from 'react-router';
import { useRepubContext } from '@cx-web/feature-repub';
import { removeRepubPrefix } from '@cx-web/utils';

// Intentional copy of app/hooks/use-current-path.ts — product-plus cannot import
// from ~/hooks/. Keep the two in sync until product-plus is extracted as a
// standalone app (NGF-6226 Phase 2). The host copy is NOT dead — it still has
// live consumers under app/routes/$/.

/**
 * The current request pathname with the repub prefix stripped (e.g. `/football`).
 *
 * Derived fresh from the router on every render, so it stays correct across SPA
 * navigations without a provider or a serialized loader field.
 */
export const useCurrentPath = () => {
  const { pathname } = useLocation();
  const { repub } = useRepubContext();

  return removeRepubPrefix(pathname, repub);
};
